export type IALMResource = IALMResourceData;
export interface IALMResourceData {
  id: string;
  name: string;
  contentType: ALMResourceContentTypes;
  location?: string;
  seatLimit?: number;
  instructorNames?: [string];
  dateStart?: string;
  completionDeadline?: string;
  duration?: number;
  desiredDuration?: number;
}

export enum ALMResourceContentTypes {
  Attachment = 'Attachment',
  Activity = 'Activity',
  Classroom = 'Classroom',
  VirtualClassroom = 'Virtual Classroom',
  Other = 'Other'
}
